export const maskEmail = (email: string): string => {
  const [local, domain] = email.split("@");
  return `${local.slice(0, 3)}***@${domain}`;
};
